<script setup>
import { defineProps, defineModel, computed } from 'vue';
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
    label: String,
    autocomplete: {
        type: String,
        default: 'off'
    },
    maxlength: {
        type: Number,
        default: 80
    },
    rules: {
        type: Array,
        default: () => []
    },
    readonly: {
        type: Boolean,
        default: false
    },
    required: {
        type: Boolean,
        default: false
    },
    fieldDefault: {
        type: Boolean,
        default: true
    },
    notLength: {
        type: Boolean,
        default: false
    }
});

const model = defineModel();

const requiredRule = (v) =>
    !!v || t('common.messages.validations.required')

const maxLengthRule = (v) =>
    (v?.length || 0) <= props.maxlength ||
    t('common.messages.info.enterMaximumCharacters', { count: props.maxlength })

const combinedRules = computed(() => {
    const rules = [...props.rules, maxLengthRule]
    if (props.required) rules.unshift(requiredRule)
    return rules
})

const inputClasses = computed(() => ({
    'field-default': props.fieldDefault,
    'input-disabled': props.readonly
}))

</script>

<template>
    <v-text-field
        v-model="model"
        rounded="xl"
        :label="label"
        :autocomplete="autocomplete"
        :counter="notLength ? null : props.maxlength"
        :maxlength="notLength ? null : props.maxlength"
        :rules="combinedRules"
        :readonly="readonly"
        :class="inputClasses"
    ></v-text-field>
</template>
